import React, { useEffect } from "react";
import styles from "./NotAvailable.module.css";
import { EmptyState } from "../EmptyState/EmptyState";
import FleekLogo from "../../asset/icons/Brand_logo_Sq.png";

const SUPPORT_EMAIL = "help@getfleek.app";

const GlobeIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
  </svg>
);

/**
 * The whole site for a visitor from a country no store is offered in
 * (market.js BLOCKED, as backend market.py BLOCKED): no catalogue, no prices,
 * no sign-in. Shown for Cloudflare's country and for a ?market= link alike.
 */
export const NotAvailable = ({ country }) => {
  useEffect(() => {
    document.title = "Not available in your country | Fleek";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <main className={styles.page}>
      <img src={FleekLogo} alt="Fleek" className={styles.logo} width="40" height="40" />
      <EmptyState
        icon={<GlobeIcon />}
        title={country ? `Fleek isn't available in ${country}` : "Fleek isn't available in your country"}
        body={
          <>
            We can't offer subscriptions where you are, so there's nothing to buy here. If you think this is a
            mistake, for example because you're travelling or using a VPN, write to{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </>
        }
      />
    </main>
  );
};

export default NotAvailable;
